import { CoreBaseApi } from "../cvp-webgames-core/Api/CoreBaseApi";
import { ChatGptEndpoint } from "./endpoint/ChatGptEndpoint";

class GameAPI extends CoreBaseApi {
    chatGpt: ChatGptEndpoint = new ChatGptEndpoint(this);
}

export const gameAPI = new GameAPI();